{
  "status": {
    "DRAFT": "Draft",
    "FINAL": "Final"
  },
  "week": {
    "of": "Week of {{day}}"
  },
  "errors": {
    "STATUS_REPORT_EXISTS": "This week already has a report. Open it from the project's reports to carry on writing.",
    "STATUS_REPORT_FINAL": "This report is final and can't be changed. Reload to see it as it was finalised.",
    "STATUS_REPORT_WEEK": "Pick this week or an earlier one, from the week the project starts.",
    "VERSION_CONFLICT": "Someone changed this report meanwhile. Reload to see their version.",
    "PROJECT_FEATURE_OFF": "The key figures can't be copied: project insights are off for this project and the week has no record. Turn insights on in the project's settings, or ask an administrator."
  },
  "sections": {
    "summary": "Summary",
    "progress": "Progress this week",
    "risksIssues": "Risks and issues",
    "nextSteps": "Next steps"
  },
  "sectionHints": {
    "summary": "The week in a few sentences. Readers see this first.",
    "progress": "What was done this week.",
    "risksIssues": "What could delay the work or cost more, and what is being done about it.",
    "nextSteps": "What happens next week, and who does it."
  },
  "figures": {
    "title": "Key figures",
    "fromRecord": "From the week's record ({{date}})",
    "live": "Live as of {{date}}",
    "refresh": "Refresh figures",
    "health": "Health",
    "progress": "Progress",
    "plannedFinish": "Planned finish",
    "forecastFinish": "Expected finish",
    "slip": "Against plan",
    "onTime": "On plan",
    "late_one": "{{n}} working day late",
    "late_other": "{{n}} working days late",
    "early_one": "{{n}} working day early",
    "early_other": "{{n}} working days early",
    "bac": "Budget",
    "ac": "Spent to date",
    "eac": "Expected final cost",
    "forecastMargin": "Expected margin",
    "billed": "Billed",
    "collected": "Collected",
    "outstanding": "Outstanding",
    "moneyHidden": "Money figures are shown to people who may see project money."
  },
  "signals": {
    "title": "Alerts that week",
    "none": "No warnings that week."
  },
  "latest": {
    "title": "Status report",
    "all": "All reports",
    "failed": "Couldn't load the status reports.",
    "retry": "Try again",
    "noSummary": "No summary yet.",
    "finalised": "Finalised by {{name}}, {{date}}",
    "updated": "Last saved {{date}}",
    "open": "Open",
    "openLabel": "Open the report for the week of {{day}}",
    "none": "No status reports yet.",
    "finish": "Finish last week's report",
    "write": "Write this week's report"
  },
  "create": {
    "title": "Write a status report",
    "description": "One report a week, Sunday to Saturday. Its key figures are copied from the project.",
    "week": "Week",
    "weekHint": "This week or an earlier one, from the week the project starts.",
    "thisWeek": "{{week}} (this week)",
    "hasReport": "{{week}}: has a report",
    "takenTitle": "This week already has a report",
    "openIt": "Open the report for the week of {{day}}",
    "notStarted": "The project hasn't started yet: a report can be written from its first week.",
    "cancel": "Cancel",
    "confirm": "Start the report",
    "failed": "The report wasn't started",
    "done": "Report started for the week of {{day}}"
  },
  "list": {
    "title": "Status reports",
    "back": "Back to {{code}}",
    "write": "Write a report",
    "tableLabel": "Status reports of {{code}}",
    "empty": "No status reports yet.",
    "emptyWrite": "Write the first one: a few lines on the week, with the figures copied for you.",
    "emptyRead": "The project's manager writes them each week.",
    "finalisedOn": "Finalised {{date}}",
    "updatedOn": "Saved {{date}}",
    "search": "Search the reports’ text",
    "clearSearch": "Clear the search",
    "noMatch": "No report mentions that.",
    "startsLater": "Reports start in the week of {{date}}, the project's first week."
  },
  "columns": {
    "week": "Week",
    "status": "Status",
    "summary": "Summary",
    "by": "By",
    "project": "Project",
    "health": "Health",
    "author": "Written by",
    "manager": "Manager",
    "lastReport": "Last report"
  },
  "editor": {
    "documentTitle": "Status report",
    "toList": "Back to the reports",
    "back": "{{code}} status reports",
    "ariaTitle": "Status report, week of {{day}}, {{code}}",
    "author": "Written by {{name}}",
    "savedAt": "Last saved {{date}}",
    "save": "Save",
    "noChanges": "Nothing to save yet",
    "saved": "Report saved",
    "finalise": "Finalise",
    "print": "Print",
    "delete": "Delete draft",
    "refreshed": "Figures refreshed",
    "finalisedToast": "Report finalised for the week of {{day}}",
    "deleted": "Draft for the week of {{day}} deleted",
    "finalTitle": "Final report",
    "finalBody": "Finalised by {{name}} on {{date}}. A final report can't be changed.",
    "readOnlyTitle": "Read only",
    "readOnlyBody": "The project's manager, or someone who manages projects, writes this report.",
    "aiAssisted": "Drafted with the assistant. Check the figures before saving.",
    "failed": "That didn't work",
    "staleTitle": "This report changed meanwhile",
    "staleBody": "Someone saved, refreshed or finalised it since you opened it. Reload to see it as it is now; copy any text you want to keep first.",
    "reload": "Reload",
    "counter": "{{n}} / {{max}}",
    "nearLimit": "Fewer than {{n}} characters left.",
    "atLimit": "Character limit reached."
  },
  "finalise": {
    "title": "Finalise the report for the week of {{day}}?",
    "body": "A final report can't be changed: its text and figures stay as they are now. Unsaved text is saved first.",
    "confirm": "Finalise"
  },
  "delete": {
    "title": "Delete the draft for the week of {{day}}?",
    "body": "The draft and its text are removed. A new report can be started for the week afterwards.",
    "confirm": "Delete draft"
  },
  "print": {
    "title": "Weekly status report",
    "back": "Back to the report",
    "week": "Week",
    "weekRange": "{{from}} to {{to}}",
    "finalised": "Finalised",
    "project": "Project",
    "customer": "Customer",
    "manager": "Project manager",
    "draft": "Draft: this report is not final yet. Its text and figures can still change.",
    "footerFinal": "Finalised by {{name}} on {{date}}.",
    "footerDraft": "Draft, last saved {{date}}."
  },
  "reading": {
    "title": "Weekly status reports",
    "range": "{{from}} to {{to}}",
    "week": "Week",
    "thisWeek": "{{week}} (this week)",
    "previousWeek": "Previous week",
    "nextWeek": "Next week",
    "status": "Status",
    "anyStatus": "Any status",
    "manager": "Manager",
    "views": "Reports or missing",
    "reports": "Reports",
    "missing": "Missing",
    "reportsLabel": "Status reports for the week of {{day}}",
    "missingLabel": "Active projects without a report for the week of {{day}}",
    "noReports": "No reports for this week yet.",
    "noneMissing": "Every active project has a report for this week.",
    "noMatch": "Nothing matches these filters.",
    "never": "None yet",
    "search": "Search projects by code or name",
    "clearSearch": "Clear the search"
  }
}
